import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { HiringService } from '../../../pages/hiring/services/hiring.service';
import { EmployeeService } from './../../../pages/employee/services/employee.service';

@Component({
  selector: 'app-review-ddmodal',
  templateUrl: './review-ddmodal.component.html',
  styleUrls: ['./review-ddmodal.component.css'],
})
export class ReviewDDModalComponent implements OnInit {
  @Input() id: string;
  accountList: any[] = [];
  accountName: string[] = ['Primary', 'Secondary', 'Third', 'Fourth'];

  constructor(
    public activeModal: NgbActiveModal,
    private employeeService: EmployeeService,
    private hiringService: HiringService
  ) {}

  ngOnInit(): void {
    this.getDirectDeposit();
  }

  getDirectDeposit(): void {
    this.hiringService.getOnboardDirectDeposits(this.id).then((response: any[]) => {
      if (response != null) {
        this.accountList = response;
        this.accountList.forEach((val: any) => {
          this.getAttachmentList(val);
        });
      }
    });
  }

  getAttachmentList(data: any): void {
    const requestParam = 'moduleID=' + 601 + '&recordID=' + data.OnboardDirectDepositID + '&onboarding=' + true;
    this.employeeService.getFileAttachmentList(requestParam).then((response: any[]) => {
      if (response != null && response.length > 0) {
        data.Attachments = response[0];
      }
    });
  }

  closeClick(): void {
    this.activeModal.close();
  }
}
